// Navigation.tsx - VERSIÓN MEJORADA
import * as React from "react";
import { motion } from "framer-motion";
import { 
  MenuItemSignOut,
  MenuItemHome,
  MenuItemMiProgreso, 
  MenuItemMisLecturas, 
  MenuItemMiPerfil, 
  MenuItemMiScore, 
  MenuCreateLecture, 
  MenuItemMiEstadistica,
  MenuItemProgreso
} from "./MenuItem.tsx";

const variants = {
  open: {
    transition: { 
      staggerChildren: 0.07, 
      delayChildren: 0.2 
    }
  },
  closed: {
    transition: { 
      staggerChildren: 0.05, 
      staggerDirection: -1 
    }
  }
};

export const Navigation = ({ SignOut, username }) => (
  <motion.ul 
    variants={variants}
    style={{
      padding: 0,
      position: 'absolute',
      top: '80px',
      width: '235px',
      paddingLeft: '20px'
    }}
  >
    <div style={{ padding: '0 16px 8px 16px', marginBottom: '8px' }}>
      <h3 style={{ 
        fontSize: '11px', 
        fontWeight: 600, 
        color: '#6b7280', 
        textTransform: 'uppercase',
        letterSpacing: '0.05em'
      }}>
        Menú Principal
      </h3>
    </div>
    
    <MenuItemHome />
    <MenuItemMiPerfil username={username} />
    <MenuItemProgreso></MenuItemProgreso>
    <div style={{ padding: '16px 16px 8px 16px', marginTop: '8px', marginBottom: '8px' }}>
      <h3 style={{ 
        fontSize: '11px', 
        fontWeight: 600, 
        color: '#6b7280', 
        textTransform: 'uppercase',
        letterSpacing: '0.05em'
      }}>
        Mi Actividad
      </h3>
    </div>
    
    <MenuItemMiProgreso />
    <MenuItemMiEstadistica />
    
    <div style={{ padding: '16px 16px 8px 16px', marginTop: '8px', marginBottom: '8px' }}>
      <h3 style={{ 
        fontSize: '11px', 
        fontWeight: 600, 
        color: '#6b7280', 
        textTransform: 'uppercase',
        letterSpacing: '0.05em'
      }}>
        Acciones
      </h3>
    </div>
    
    <MenuCreateLecture />
    <MenuItemSignOut SignOut={SignOut} />
  </motion.ul>
);